import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueRenderer } from "abreact/data/AbDataValueRenderer";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import { AbMarkdownLexical } from "abreact/input/markdown/AbMarkdownLexical";
import { StringUtils } from "abweb/utils/StringUtils";
import * as React from "react";
export function AbMarkdownDataValueInput(props) {
  const viewModel = AbFormHooks.useDataValueInputViewModel("ab-integer-data-value-input", props);
  if (!viewModel) {
    return null;
  }
  const currentValue = viewModel.currentValue;
  return !viewModel.isEditing ? currentValue != null && props.valueRenderer ? /*#__PURE__*/React.createElement("div", viewModel.readOnlyProps, props.valueRenderer(currentValue)) : /*#__PURE__*/React.createElement(AbDataValueRenderer, _extends({}, viewModel.readOnlyProps, {
    subject: props.subject,
    accessor: props.accessor,
    currentValue: currentValue
  })) : /*#__PURE__*/React.createElement(AbMarkdownLexical, _extends({}, viewModel.inputProps, {
    resizable: true,
    value: StringUtils.emptyIfNull(currentValue),
    onChange: newString => {
      viewModel.changeValue(newString !== "" ? newString : null);
    }
  }));
}
//# sourceMappingURL=AbMarkdownDataValueInput.js.map
